import React from 'react';
import { asField } from 'informed';
import { IDocumentType } from '../../common/types';
import { toggleDocumentSelection } from './processDocumentSelection';

type Props = {
  options: IDocumentType[],
  fieldState: { value?: IDocumentType[] },
  fieldApi: { setValue: (documents: IDocumentType[]) => void },
};

const TransferDocumentTypeChecklist = ({ options, fieldState, fieldApi }: Props) => {
  const selected = fieldState.value || [];
  const onChange = fieldApi.setValue;
  const selectedIds = new Set(selected.map(documentType => documentType.id));

  return (
    <div className="w-100 mb-3">
      <div className="d-flex justify-content-end mb-2">
        <button
          type="button"
          className="btn btn-link p-0 mr-3"
          onClick={() => onChange(options)}
        >
          Selecionar todos
        </button>
        <button
          type="button"
          className="btn btn-link p-0"
          onClick={() => onChange([])}
        >
          Limpar seleção
        </button>
      </div>
      <div className="row">
        {options.map(documentType => (
          <div className="col-md-6 col-sm-12 mb-2" key={documentType.id}>
            <label className="input-check-type w-100">
              {documentType.name}
              <input
                className="checkbox"
                type="checkbox"
                checked={selectedIds.has(documentType.id)}
                onChange={() => onChange(
                  toggleDocumentSelection(selected, documentType)
                )}
              />
              <span className="checkmark" />
            </label>
          </div>
        ))}
      </div>
      {!options.length && (
        <p className="text-muted mb-0">
          Nenhum tipo de documento está disponível para transferência.
        </p>
      )}
    </div>
  );
};

export default asField(TransferDocumentTypeChecklist);
